import { useUserAnalysis } from '.'
import { RouteLocationNormalized } from 'vue-router'
export const routerAnalysisGuard = (_: RouteLocationNormalized, from: RouteLocationNormalized) => {
  const { isInitialized, startSession, trackPageNavigation } = useUserAnalysis()
  if (!isInitialized) {
    startSession()
  } else {
    trackPageNavigation(from)
  }
}
